import { useEffect, useState } from "react";
import api from "services/api";
import NAVBAR from "components/navbar";
import config from "config";
import { getcodCidade } from "functions/gettabconfig";
import DIALOGLOJADETALHE from "dialog/dialoglojadetalhe";
import Participantes from "components/participantes";
import './style.css';

function LISTAPARTICIPANTES() {
    const [pppDParticipante, setpppDParticipante] = useState(false);
    const [dados, setDados] = useState({});
    const [lparticipante, setLParticipante] = useState([]);
    const [searchTerm, setSearchTerm] = useState(""); // Estado para o termo de busca
    const [filteredParticipantes, setFilteredParticipantes] = useState([]); // Estado para a lista filtrada

    const openDetalhe = (d) => {
        setDados(d);
        setpppDParticipante(true);
    };

    useEffect(() => {
        // Busca Participantes
        api.get(`${config.ESTABELECIMENTOS}?cod_cidade=${getcodCidade()}`)
            .then(response => {
                setLParticipante(response.data);
                setFilteredParticipantes(response.data); // Inicializa a lista filtrada
            })
            .catch(error => {
                console.log(error);
            });
    }, []);

    useEffect(() => {
        // Filtra os participantes com base no termo de busca
        setFilteredParticipantes(
            lparticipante.filter(participante =>
                participante.nome.toLowerCase().includes(searchTerm.toLowerCase())
            )
        );
    }, [searchTerm, lparticipante]);

    return (
        <div className="container-fluid mt-page">
            <NAVBAR />
            <div>
                <h1>Participantes</h1>
                <div className="mb-3">
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Buscar por nome..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)} // Atualiza o termo de busca
                    />
                </div>
                <div className="row">
                    {filteredParticipantes.map((b) => {
                        return (
                            <div
                                key={`part${b.id_estabelecimento}`}
                                className="col-12 col-sm-6 col-md-4 p-2"
                            >
                                <Participantes
                                    nome={b.nome}
                                    endereco={`${b.endereco},${b.complemento}`}
                                    telefone={b.telefone}
                                    whatsup={b.whatsup}
                                    foto={b.url_foto}
                                    logo={b.url_logo}
                                    dados={b}
                                    site={openDetalhe}
                                />
                            </div>
                        );
                    })}
                </div>
            </div>
            <DIALOGLOJADETALHE
                trigger={pppDParticipante}
                setTrigger={setpppDParticipante}
                dados={dados}
            />
        </div>
    );
}

export default LISTAPARTICIPANTES;